// extracted by mini-css-extract-plugin
export default {"headerBody":"X5IRl oeY6d gfZK6","headerTextInput":"ZqOfw FhFee","headerSchema":"AkKxs av9xi"};